export const experienceData = [
  {
    id: 1,
    company: "Vishnu Ads and Ventures Pvt Ltd ",
    jobtitle: "MERN-FullStack Developer Intern",
    startYear: "2024",
    endYear: "Present",
  },
  {
    id: 2,
    company: "BankBazaar",
    jobtitle: "Senior Customer Relationship Officer",
    startYear: "2023",
    endYear: "2024",
  },
  {
    id: 3,
    company: "TeamLease Pvt Ltd",
    jobtitle: "Customer Relationship Officer",
    startYear: "2022",
    endYear: "2023",
  },
];